import React, {useState} from 'react';
import AdminLayout from "@/components/layout/admin/adminLayout";
import {URLS} from "@/lib/urls";
import toFaNumber from "@/lib/utils/number";
import RenderIf from "@/components/render-if";
import {Button, Tag} from "antd";
import TableSearch from "@/components/table/tableSearch";
import {Link} from "react-router-dom";
import {sprintf} from "@/lib/utils/sprintf";
import {useApiSearchAdminTopics} from "@/api/topic";
import PermList from "@/lib/helper/PermList";
import {Can} from "@/components/can/Can";


function AdminTopicListPage(props) {

    const [needRefetch, setNeedRefetch] = useState(false)
    const [status, setStatus] = useState('')


    const columns = [
        {
            title: '#',
            dataIndex: 'code',
            key: 'code',
            render: function (text, record) {
                return toFaNumber(text)
            }
        },

        {
            title: 'عنوان',
            dataIndex: 'title',
            key: 'title',
            render: function (text, record) {
                return (<>
                    <div className="flex gap-1">
                        {text}
                    </div>

                </>)

            }
        },
        {
            title: 'قیمت',
            dataIndex: 'price',
            key: 'price',
            render: function (text, record) {
                return (
                    <>
                        <div className="flex flex-wrap gap-1">
                            <div>
                                <RenderIf condition={!!record?.price} falsyElement={<>
                                    <span>رایگان</span>
                                </>}>
                                    <div className={'flex gap-1 items-center'}>
                                        <span>{record.price.toLocaleString()}</span>
                                        <span className={'text-xs text-gray-400'}>تومان</span>
                                    </div>

                                </RenderIf>
                            </div>
                            <div>
                                <RenderIf condition={!!record.installment}>
                                    <Tag className={'text-xs'} color={'green'}>
                                        <span className={'text-xs'}>قسطی</span>
                                    </Tag>
                                </RenderIf>
                            </div>

                        </div>

                    </>

                )
            }
        },

        {
            title: '',
            dataIndex: 'id',
            key: 'edit',
            render: function (text, record) {
                return (
                    <Can permission={PermList.TOPIC_VIEW}>
                        <Link to={sprintf(URLS.admin.topic.view, {id: record.id})}>
                            <Button type={'dashed'} size={'small'}>
                                جزئیات
                            </Button>
                        </Link>
                    </Can>
                    )

            }
        },
    ]


    return (
        <AdminLayout pageTitle={'لیست سرفصل‌ها'} backTo={URLS.admin.dashboard}>

            <TableSearch
                searchInput={true}
                addButton={<>
                    <div className="flex flex-wrap gap-1 justify-between">
                        <div className="flex flex-wrap gap-1 items-center mx-1">

                        </div>

                    </div>


                </>}
                apiFn={useApiSearchAdminTopics}
                needRefetch={needRefetch}

                setNeedRefetch={setNeedRefetch}
                columns={columns}/>

        </AdminLayout>
    );
}

export default AdminTopicListPage;